import { Button, Typography } from 'antd';
import React from 'react';
import { AiOutlineMail } from 'react-icons/ai';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import useAuthorizationHook from '../../hooks/useAuthorizationHook';
import { IReportState } from '../../model/ReportModel';
import { useReportStore } from '../../stores/ReportStore';
import LoadingModalComponent from '../CommonComponent/LoadingModalComponent';
const DateFilterComponentLoadable = React.lazy(() => import('../FilterComponent/IRSManifestApprovalReport'));

function IRSManifestApprovalReportComponent() {
    const { promiseInProgress } = usePromiseTracker({ area: 'manifest-report-area' });
    const DownloadIRSManifestApprovalReportAction = useReportStore((state: IReportState) => state?.DownloadIRSManifestApprovalReportAction);

    const onDownloadClicked = (data: any) => {
        trackPromise(DownloadIRSManifestApprovalReportAction(data), 'manifest-report-area')
 
    };

    return (
        <>
            <Typography.Title level={4} > IRS Manifest Approval Report </Typography.Title>
            <LoadingModalComponent isLoading={promiseInProgress }>
                <DateFilterComponentLoadable onSearchClicked={onDownloadClicked} isResetButton={false} >
                </DateFilterComponentLoadable>
            </LoadingModalComponent>
        </>
    )
}

IRSManifestApprovalReportComponent.propTypes = {}

export default IRSManifestApprovalReportComponent